export enum SupplierProductAssortmentDeliveryStatus {
    DeliveryAllowed = 0,
    StopOrder = 1,
    StopSales = 2
}

(SupplierProductAssortmentDeliveryStatus as any).__typeName = 'SupplierProductAssortmentDeliveryStatus';